import { MarkAsSpamReason } from '@app/models'
import { communicationsApi } from '@app/services'

export const markMessageAsSpam = async (
  conversationId: number,
  messageId: number,
  reason: MarkAsSpamReason,
  signal: AbortSignal
) => {
  const { data } = await communicationsApi.post(`/conversation/${conversationId}/spam`, {
    messageId,
    reason
  }, {
    signal
  })
  return data
}
